import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { User } from "../interfaces/DTO/user";
import { JWTPayload } from "../interfaces/DTO/auth";

// טיפוס JWT (מותאם למבנה שהשרת מחזיר)


interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  auth: JWTPayload | null;
  redirectPath: string | null;

  setAuthenticated: (
    auth: boolean,
    user?: User,
    payload?: JWTPayload
  ) => void;
  clearAuth: () => void;
  setRedirectPath: (path: string | null) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      isAuthenticated: false,
      user: null as User | null,
      auth: null as JWTPayload | null,
      redirectPath: null as string | null,
      
      setAuthenticated: (auth, user, payload) =>
        set({
          isAuthenticated: auth,
          user: (user ?? null) as User | null,
          auth: payload ?? null,
        }),

      clearAuth: () =>
        set({
          isAuthenticated: false,
          user: null,
          auth: null,
          redirectPath: null,
        }),

      setRedirectPath: (path: string | null) => set({ redirectPath: path }),
    }),
    { name: "AuthStore" }
  )
);
